if (!customElements.get('collection-description')) {
  customElements.define('collection-description', class extends HTMLElement {
    connectedCallback() {
      this.preview = this.querySelector('[data-description-preview]');
      this.full = this.querySelector('[data-description-full]');
      this.toggle = this.querySelector('[data-description-toggle]');
      if (!this.preview || !this.full || !this.toggle) return;

      this.expanded = false;
      this.onToggle = () => {
        this.expanded = !this.expanded;
        this.render();
      };
      this.toggle.addEventListener('click', this.onToggle);
      this.observer = new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          this.measure();
        }
      });
      this.observer.observe(this);
      this.measure();
      document.fonts.ready.then(() => {
        if (this.isConnected) this.measure();
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.toggle?.removeEventListener('click', this.onToggle);
    }

    measure() {
      for (const element of [this.preview, this.full]) {
        element.setAttribute('data-measuring', '');
        element.hidden = false;
      }
      const style = getComputedStyle(this);
      const limit = parseFloat(style.lineHeight) * parseInt(style.getPropertyValue('--description-lines'), 10);
      this.overflows = this.preview.scrollHeight > limit + 1 || this.full.scrollHeight > limit + 1;
      for (const element of [this.preview, this.full]) {
        element.removeAttribute('data-measuring');
      }
      this.render();
    }

    render() {
      const collapsed = this.overflows && !this.expanded;
      this.preview.hidden = !collapsed;
      this.full.hidden = collapsed;
      this.toggle.hidden = !this.overflows;
      this.toggle.setAttribute('aria-expanded', String(!collapsed));
      this.toggle.textContent = collapsed ? this.toggle.dataset.labelMore : this.toggle.dataset.labelLess;
    }
  });
}
